export default "__VITE_ASSET__384a5bae__"